import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../../api/axiosInstance";

// ----------- Async Thunk (UPDATE SMTP settings) -----------
export const updateSmtpSettings = createAsyncThunk(
  "smtpSettings/update",
  async (data, thunkAPI) => {
    try {
      const response = await api.post("/dashboard/general-settings/smtp-settings", data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);

// ----------- Slice -----------
const smtpSettingsSlicer = createSlice({
  name: "smtpSettings",
  initialState: {
    data: null,
    loading: false,
    error: null,
    successMessage: "",
  },
  reducers: {
    clearSmtpSettingsState: (state) => {
      state.data = null;
      state.loading = false;
      state.error = null;
      state.successMessage = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateSmtpSettings.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateSmtpSettings.fulfilled, (state, action) => {
        state.loading = false;
        state.successMessage = action.payload?.message || "";
      })
      .addCase(updateSmtpSettings.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearSmtpSettingsState } = smtpSettingsSlicer.actions;
export default smtpSettingsSlicer.reducer;